// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Skeleton, Text } from '@mantine/core';
import { useContext } from 'react';
import { ContractContext } from '../../../Service/Context/ContractContextV2';
import { openFilePickerModal } from '../../../Molecules/Dialogs/FilePickerModal';
import { BookitupEntity } from '../../../Service/FileS';
import BookitupEntityPreview from '../../../Atoms/BookitupEntityPreview';
import LinkText from '../../../Atoms/LinkText';

const ContractPdfSection = () => {
  const { contract, loading, savePatch } = useContext(ContractContext);

  const {
    profileId,
    frontCoverFileName,
    frontCoverEntityId,
    frontCoverEntityType,
    backCoverEntityId,
    backCoverEntityType,
    backCoverFileName,
  } = contract ?? {};

  return (
    <>
      <Text weight="bolder" size="lg" mb="md">
        PDFs beifügen
      </Text>
      <Text mb="md">Fügen Sie dem Vertrag ein beliebiges PDF bei </Text>

      {frontCoverFileName && (
        <BookitupEntityPreview
          entityId={frontCoverEntityId}
          entityType={frontCoverEntityType}
          filename={frontCoverFileName}
          onDelete={() => savePatch({ frontCoverFileName: null })}
        />
      )}
      {!frontCoverFileName && profileId && (
        <LinkText
          onClick={() =>
            openFilePickerModal({
              profileId: profileId.toString(),
              onSelect: (entity: BookitupEntity) => {
                const { fileName } = entity;
                savePatch({ frontCoverFileName: fileName });
              },
              allowedExtensions: ['pdf'],
            })
          }
        >
          + PDF-Datei auswählen
        </LinkText>
      )}
      {loading && <Skeleton height={40} />}
      <Text size="xs" color="dimmed" mb="md">
        Wähle eine PDF-Datei, die{' '}
        <Text span weight="bolder">
          {' '}
          vor
        </Text>{' '}
        dem Dokument eingefügt werden soll
      </Text>
      {backCoverFileName && (
        <BookitupEntityPreview
          entityId={backCoverEntityId}
          entityType={backCoverEntityType}
          filename={backCoverFileName}
          onDelete={() => savePatch({ backCoverFileName: null })}
        />
      )}
      {!backCoverFileName && profileId && (
        <LinkText
          onClick={() =>
            openFilePickerModal({
              profileId: profileId.toString(),
              onSelect: (entity: BookitupEntity) => {
                const { fileName } = entity;
                savePatch({ backCoverFileName: fileName });
              },
              allowedExtensions: ['pdf'],
            })
          }
        >
          + PDF-Datei auswählen
        </LinkText>
      )}
      {loading && <Skeleton height={40} />}
      <Text size="xs" color="dimmed">
        Wähle eine PDF-Datei, die{' '}
        <Text span weight="bolder">
          {' '}
          nach
        </Text>{' '}
        dem Dokument eingefügt werden soll
      </Text>
    </>
  );
};

export default ContractPdfSection;
